import { IconButton, Typography } from '@mui/material';
import { useDocketDateRange } from '../docket-day-hook';
import { Button, FlexContainer, IconLibrary } from '@act/storybook';
import { useMobile } from '@act/utilities/mobile-context';

const DocketHeader = () => {
  const { date, goForward, goBack, goToToday } = useDocketDateRange();
  const { isMobile } = useMobile();
  const dateString = date.toFormat('MMM dd, yyyy');

  return (
    <FlexContainer
      direction="row"
      gap={isMobile ? 0 : 2}
      alignItems="center"
      padding={isMobile ? '0 8px' : '0 24px'}
      width="100%"
    >
      <Button
        onClick={goToToday}
        variant="outlined"
        sx={{ marginRight: isMobile ? 'auto' : undefined }}
      >
        Today
      </Button>
      <IconButton onClick={goBack}>
        <IconLibrary iconName="CaretLeft" size={28} weight="regular" />
      </IconButton>
      <FlexContainer direction="row" alignItems="center">
        <Typography
          variant="titleLarge"
          color="primary"
          sx={{
            flex: 1,
            minWidth: 0,
          }}
        >
          {dateString}
        </Typography>
      </FlexContainer>
      <IconButton onClick={goForward}>
        <IconLibrary iconName="CaretRight" size={28} weight="regular" />
      </IconButton>
    </FlexContainer>
  );
};

export default DocketHeader;
